export default "__VITE_ASSET___rpiJlct__";